import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'

// ----------------------------------------------------------------------

i18n
  .use(LanguageDetector)
  .use(backend)
  .use(initReactI18next)
  .init({
    lng: 'th',
    fallbackLng: 'th',
    supportedLngs: ['th', 'my'],
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    // react-i18next options
    react: {
      useSuspense: false,
    },
  })

export default i18n
